import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: "https://api.afrikanbbq.com/api/",
  // baseURL: "https://afrikanbbqapi.hnh.mycompanyportfolio.com/api/",
  // baseURL: "https://afrikanbbq.mycompanyportfolio.com/api/",
  // baseURL: "https://africanbbqapi.devssh.xyz/api/",

  // >>>>>>> 61beaf7b5de8e0970b6bbf8e85df52ef6276fe88
  // baseURL: "https://afrikanbbq.devssh.xyz/api/",
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// axiosInstance.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (error) {
//     const Data = error?.response?.data;
//     const errors = Data.errors;
//     if (errors) {
//       for (const key in errors) {
//         if (Object.hasOwnProperty.call(errors, key)) {
//           toast.error(errors[key]);
//         }
//       }
//     } else {
//       toast.error(Data.message);
//     }
//     // if (Data.message === "Unauthenticated.") {
//     //   localStorage.clear();
//     //   window.location.reload();
//     //   window.location.href = "/login";
//     // }
//     // return Promise.reject(error);
//   }
// );
